import { Row, Col, Image, Card } from 'antd'
import { useQuery } from 'react-query'
import noCarImage from '../../../assets/camera.png'
import MyCard from '../../../components/MyCard/MyCard'


export default function ContractInfo() {
    const { data } = useQuery('getContractInfo')

    const style = {
        text: {
            fontSize: 14,
            fontWeight: 'bold',
            marginBottom: 10,
            textDecoration: 'underLine',
            display: "flex"
        }
    }

    return <MyCard title="Στοιχεία Συμβολαίου" >
        <Row >
            <Col span={8}><Image src={data.carPhotoUrl==='' ? noCarImage : data.carPhotoUrl} alt="anytimeLogo" width="100" preview={false} /></Col>
            <Col push={1} span={15}>
                <Card>
                    <Col style={style.text} span={24}>Αριθμός κυκλοφορίας: {data.plateNumber}</Col>
                    <Col style={style.text} span={24}>Διάρκεια ασφάλισης: {data.startDate} - {data.endDate}</Col>
                    <Col style={style.text} span={24}>Σύνολο χιλιομέτρων: {data.currentPackageDuration} Χιλιόμετρα</Col>
                    <Col style={style.text} span={24}>Υπόλοιπο χιλιομέτρων:  {(data.currentPackageDuration - data.kilometers).toFixed(2)} Χιλιόμετρα</Col>
                </Card>
            </Col>
        </Row>
    </MyCard >



}